module.exports = __webpack_public_path__ + "img/SKMA_emergency1.9c73d5e5.jpg";